// Cookie.js
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

export default function Cookie() {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const accepted = localStorage.getItem("cookieAccepted");
        if (!accepted) {
            setVisible(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem("cookieAccepted", "true");
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="cookie-banner" id="cookie-banner">
            <div className="content">
                <p className="text-md">
                    We use cookies to ensure you get the best experience on our website.
                    By continuing, you accept our cookie policy.
                </p>
                <div className="button-group">
                    <Link
                        className="btn-out-line-white btn-submit-total tf-btn"
                        to="/privacy-policy"
                    >
                        Privacy Policy
                    </Link>

                    <button
                        onClick={acceptCookies}
                        className="accept-button btn-out-line-white btn-submit-total tf-btn"
                    >
                        Accept Cookies
                    </button>
                </div>
            </div>
        </div>
    );
}
